'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["$scope", "$timeout", "$q", "HighChartFactory", "ChartAnalysisFactory", "VuFactory", "MessageDataStructure", "trainData", "boxDiscriminationInfo", "TimeZoneFactory", "CsvFactory",  "$filter", 
function ($scope, $timeout, $q, HighChartFactory, ChartAnalysisFactory, VuFactory, MessageDataStructure, trainData, boxDiscriminationInfo, TimeZoneFactory, CsvFactory, $filter) {
    var vu = this;
    vu.parent = $scope.$parent.base;
    var name = 'vu';

    var vuMessageData;
    var chart = undefined;
    vu.chartHidden = true;

    var init = function () {
        "use strict";
        var own = vu.parent.getChildByName(name);
        own.loaded.deferred.resolve();

        vu.responseCode = undefined;
        vu.minTime = 0;
        vu.maxTime = 60;
        vu.selectedVu = "All";
        vu.messageStructure = new MessageDataStructure(boxDiscriminationInfo);
        vu.messageStructure.setInitialState("virtualUser");
        vu.chart = undefined;
    };

    var checkChartProperties = function (properties) {
        properties.forEach(function (property) {
            switch (property.name) {
                case "dnsTime":
                case "connectTime":
                case "applicationConnectTime":
                case "preTransferTime":
                case "redirectTime":
                case "totalTime":
                    property.checked = true;
                    break;
                default:
                    property.checked = false;
            }
        });
    };
    $scope.$on('activate-' + name, function () {
        "use strict";
        if (util.isDefined(vu.chart)) {
            vu.chart.reflow();
        } else {
            vu.chart = HighChartFactory.createVuChart('vu-chart-container');
            var messageName = vu.messageStructure.getCurrentState().messageName;
            checkChartProperties(vu.messageStructure.getCurrentProperties());
            var properties = vu.messageStructure.getCheckedProperties(messageName);
            ChartAnalysisFactory.createAxes(vu.chart, properties);
            VuFactory.createVuSeries(vu.chart, messageName, properties, vu.messageStructure);
        }
        fetchMessageData().then(function () {
            renderVuGraph();
        });
    });

    var createTimestampSiteMap = function (data) {
        var map = new Map();
        data.forEach(function (entry) {
            map.set(entry.timestamp, entry.testSite);
        });
        return map;
    };
    /**
     * Function to extract the necessary data from a data object.
     * In this case we need an x,y array with timestamp x and property value y.
     * @param property      -   Object describing which field of the object we require.
     * @param object        -   The data object
     * @returns {Array}
     */
    var createSeriesEntryFromProperty = function (property, object) {
        var chartObject = [];
        //normal axis
        var propertyValue = object[property.name];

        if (typeof propertyValue == "boolean") {
            if (propertyValue) {
                propertyValue = 1;
            } else {
                propertyValue = 0;
            }
        }

        chartObject.push(object.timestamp);
        chartObject.push(propertyValue);
        return chartObject;
    };

    $scope.$on('de-activate-' + name, function () {
        "use strict";
    });

    vu.allResponseCodes = function () {
        vu.responseCode = "all";
    };

    vu.filterVu = function () {
        fetchMessageData().then(function () {
            renderVuGraph();
        });
    };
    /**
     * Zooms the chart to the initial zoom level ( maximum )
     */
    vu.zoomOut = function () {
        vu.chart.zoomOut();
    };

    /**
     * Downloads the chart as a CSV file.
     */
    vu.downloadCSV = function () {
        var csvString = HighChartFactory.createHighStockCSVString(vu.chart);
        var downloadName = "";

        if (trainData.isTrip) {
            downloadName = "vu_P" + trainData.projectId + "_T" + trainData.relativeTrainId + "_" + trainData.trajectory;
        } else {
            downloadName = "vu_P" + trainData.projectId + "_T" + trainData.relativeTrainId;
        }

        downloadName += "_" + $filter('tzdate')(trainData.from, 'YYYY-MM-DD HH:mm:ss') + "_" + $filter('tzdate')(trainData.to, 'YYYY-MM-dd HH:mm:ss') + ".csv";

        CsvFactory.download(csvString, downloadName);
    };
    /**
     * Downloads the chart as a PNG file.
     */
    vu.downloadPNG = function () {
        vu.chart.exportChart();
    };

    var fetchMessageData = function () {
        "use strict";
        var deferred = $q.defer();
        VuFactory.getVuMessageData(vuMessageData, trainData, function (data, fetched) {
            if (fetched) {
                vuMessageData = data;
                vuMessageData.forEach(function (vuResult) {
                    vuResult.timestamp = vuResult.timestamp
                });

                vu.vuSites = VuFactory.getParsedUrls(vuMessageData);
            }
            deferred.resolve();
        });
        return deferred.promise;
    };

    /**
     * Returns an x value when the the current x value is not close enough to the previous x value
     * @param {Number} current          The current x value (distance)
     * @param {Number} previous         The previous x value (distance)
     * @param {Number} interval         The interval for the data
     * @returns {Number|undefined}      An x value where we need to insert a 'null', if any
     */
    var getInsertNullForXValue = function (current, previous, interval) {
        if (current - previous > interval * 1000) {
            return previous + (1000 * interval);
        }
    };

    function renderVuGraph() {
        if (util.isDefined(vuMessageData)) {
            vu.responseCode = (util.isDefined(vu.responseCode) && vu.responseCode != "") ? vu.responseCode : "all";
            var data = VuFactory.filterData(vuMessageData, vu.selectedVu, vu.responseCode, vu.minTime, vu.maxTime, !util.isDefined(vu.vuStatistics));
            vu.vuStatistics = VuFactory.calculateVUStatistics(data);
            vu.vuCodeStatistics = VuFactory.filterCodeStatistics(data);

            vu.chart.timestampSiteMap = createTimestampSiteMap(data);
            var messageName = vu.messageStructure.getCurrentState().messageName;
            var properties = vu.messageStructure.getCheckedProperties(messageName);
            ChartAnalysisFactory.addDataToChart(vu.chart, data, messageName, properties, vu.messageStructure, createSeriesEntryFromProperty, getInsertNullForXValue, true);

            vu.chart.redraw();
            vu.chart.reflow();

            vu.chartHidden = false;
        }
    }

    init();
}];